<template>
  <div id="contenedor-contratista-contrato-generales">
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                NÚMERO DE CONTRATO
              </span>
            </div>
            <div>
              <span> {{ getContrato.numero }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                ¿CÓMO SE CONTRATÓ?
              </span>
            </div>
            <div>
              <span> {{ getContrato.comoSeContrato }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                CONTRATISTA
              </span>
            </div>
            <div>
              <span v-if="getContrato.contratista">
                {{ getContrato.contratista.nombreRazonSocial }}
              </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                OBJETO
              </span>
            </div>
            <div>
              <span> {{ getContrato.meta }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE CONTRATO
              </span>
            </div>
            <div>
              <span> {{ $moment(getContrato.fecha).format('DD/MM/YYYY') }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE INICIO
              </span>
            </div>
            <div>
              <span> {{ $moment(getContrato.fechaInicio).format('DD/MM/YYYY') }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE TERMINO
              </span>
            </div>
            <div>
              <span> {{ $moment(getContrato.fechaTermino).format('DD/MM/YYYY') }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                ¿ES OBRA FINANCIADA?
              </span>
            </div>
            <div>
              <span> {{ getContrato.esObraFinanciada ? 'SI' : 'NO' }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="getContrato.esObraFinanciada">
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE COSTO DIRECTO
              </span>
            </div>
            <div>
              <span> {{ getContrato.importeCostoDirecto | currency }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PORCENTAJE INDIRECTOS
              </span>
            </div>
            <div>
              <span> {{ getContrato.porcentajeCostoIndirectos }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE INDIRECTOS
              </span>
            </div>
            <div>
              <span> {{ getContrato.importeCostoIndirectos | currency }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PORCENTAJE DE UTILIDAD
              </span>
            </div>
            <div>
              <span> {{ getContrato.porcentajeUtilidad }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE DE UTILIDAD
              </span>
            </div>
            <div>
              <span> {{ getContrato.importeUtilidad | currency }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PORCENTAJE ADICIONALES
              </span>
            </div>
            <div>
              <span> {{ getContrato.porcentajeCargosAdicionales }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE ADICIONALES
              </span>
            </div>
            <div>
              <span> {{ getContrato.importeCargosAdicionales | currency }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PORCENTAJE COSTO FINANCIERO
              </span>
            </div>
            <div>
              <span> {{ getContrato.porcentajeCostoFinanciero }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                {{ getContrato.importeTotal | currency }}
              </span>
            </div>
            <div>
              <span>IMPORTE SIN FINANCIAMIENTO</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE COSTO FINANCIERO
              </span>
            </div>
            <div>
              <span> {{ getContrato.importeCostoFinanciero | currency }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IMPORTE
              </span>
            </div>
            <div>
              <span> {{ getContrato.importe | currency }} </span>
            </div>
            </v-col>
            <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                IVA
              </span>
            </div>
            <div>
              <span> {{ getContrato.iva | currency }} </span>
            </div>
            </v-col>
            <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                TOTAL
              </span>
            </div>
            <div>
              <span> {{ getContrato.total | currency }} </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {
  name: 'ContratistasContratoGenerales',
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getEstatus() {
      if (!this.contrato.estatus) return {};
      return this.contrato.estatus;
    },
  },
};
</script>

<style lang="scss">

</style>
